import { render } from "./PlanDetalle.vue?vue&type=template&id=452e38d1&scoped=true"
import script from "./PlanDetalle.vue?vue&type=script&lang=js"
export * from "./PlanDetalle.vue?vue&type=script&lang=js"

import "./PlanDetalle.vue?vue&type=style&index=0&id=452e38d1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452e38d1"]])

export default __exports__